import EastIcon from '@mui/icons-material/East';
import { getClassName } from "~/utils/utils";

interface IArrowRight {
	className?: string;
	size?: "normal" | "small";
}

const SIZES = {
	normal: 50,
	small: 35,
};

export default function ArrowRight({
	className = "",
	size = "normal",
}: IArrowRight) {
	const pxSize = size === "normal"
		? SIZES.normal
		: SIZES.small;

	return <EastIcon className={getClassName(["arrow-right", className])} sx={{ width: `${pxSize}px`, height: `${pxSize}px`, color: "var(--color-title)" }} />;
}
